<div #editorContainer class="monaco-editor-host" [ngStyle]="containerStyle"></div>
